import React, {FC, memo, useState} from 'react';
import Authentication from '.';
import {UserContext} from '../contexts/user-context';
import {Children, HexosparkUser, User} from '../types';

const Context: FC<Children> = ({children}) => {
  const [user, setUser] = useState<User | null>(null);
  const [hexosparkUser, setHexosparkUser] = useState<HexosparkUser | null>(null);
  return (
    <UserContext.Provider value={{user, setUser, hexosparkUser, setHexosparkUser}}>
      <Authentication>{children}</Authentication>
    </UserContext.Provider>
  );
};

export default memo(Context);
